import React from "react";
import { StencilProvider } from "@amzn/stencil-react-components/context";
import { Col } from "@amzn/stencil-react-components/layout";
import { H1, Label } from "@amzn/stencil-react-components/text";
import { getText } from "../../utils/pantherHelper";
import { sendMetrics } from "../../reporting/adobeMetrics";

class ChatEndedPage extends React.Component {
  constructor(props) {
    super(props);
    this.titleRef = React.createRef();
  }

  async componentDidMount() {
    // Set dynamic title based on feature type
    const isGrievancePhone =
      this.props.configuration?.feature === "GRIEVANCE_REPORTING_PHONE";
    const endedTitle = isGrievancePhone
      ? "Candidate Care - Chat has ended"
      : getText(this.props.bundle, "chat-closure-page-title");

    document.title = endedTitle;
    this.titleRef.current?.focus();
    await sendMetrics({
      country: this.props.configuration.country,
      language: this.props.configuration.language,
      business: this.props.configuration.business,
      channel: this.props.configuration.channel,
      ingressPoint: this.props.ingressPoint,
      event: "end chat",
    });
  }

  render() {
    const { bundle } = this.props;
    return (
      <StencilProvider>
        <Col alignItems={"center"} padding={"1rem"}>
          <H1
            ref={this.titleRef}
            tabIndex="-1"
            dataTestId={"chat-closure-prompt-title"}
          >
            {getText(bundle, "chat-closure-prompt-title")}
          </H1>
          <Label dataTestId={"chat-closure-prompt"}>
            {getText(bundle, "chat-closure-prompt")}
          </Label>
        </Col>
      </StencilProvider>
    );
  }
}

export default ChatEndedPage;
